export default __webpack_public_path__ + "static/media/learn-placeholder-2.a81d51a1.png";